export default "__VITE_ASSET__Deaeb620__"